module.exports = __webpack_public_path__ + "060dac4f1acc72e3d436376d038e8a17.pdf";